import { ExpirationController } from './expiration.controller'

function expiration () {
  return {
    restrict: 'E',
    scope: {
      date: '<'
    },
    templateUrl: '/admin/directives/expiration/expiration-directive.html?$$REVISION$$',
    controller: ExpirationController
  }
}

export { expiration }
